import clsx from 'clsx'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher} from '../../../partials'
import {useLayout} from '../../core'
import Flag from 'react-world-flags'
import Select from 'react-select'
import {useAuth} from '../../../../app/modules/auth'
const customStyles = {
  control: (base: any) => ({
    ...base,
    border: '1px solid rgba(236, 111, 102, 0.1)',
    boxShadow: 'rgba(236, 111, 102, 0.04) 0px 3px 5px',
    cursor: 'pointer',
    background: '#fff',
    height: '40px',
    width: '100%',
    textAlign: 'center',
    paddingLeft: '10px',
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    display: 'none',
    // Hide the dropdown icon
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    display: 'none', // Remove the separator line between the indicator and the control
  }),
}

const itemClass = 'ms-1 ms-lg-3'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'svg-icon-1'
const options2 = [
  // {
  //   value: 'LKR',
  //   label: (
  //     <div style={{display: 'flex', alignItems: 'center'}}>
  //       <Flag code='LK' style={{width: 20, height: 15, marginRight: 10}} />
  //       LKR
  //     </div>
  //   ),
  // },
  {
    value: 'USD',
    label: (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <Flag code='US' style={{width: 20, height: 15, marginRight: 10}} />
        USD
      </div>
    ),
  },
  {
    value: 'IDR',
    label: (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <Flag code='ID' style={{width: 20, height: 15, marginRight: 10}} />
        IDR
      </div>
    ),
  },
]
const Navbar = () => {
  const {config} = useLayout()
  const {currentUser} = useAuth()
  const defaultValue = options2.find((option) => option.value === 'IDR')
  return (
    <div className='app-navbar flex-shrink-0'>
      {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
        <Search />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div id='kt_activities_toggle' className={btnClass}>
          <KTSVG path='/media/icons/duotune/general/gen032.svg' className={btnIconClass} />
        </div>
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={btnClass}
        >
          <KTSVG path='/media/icons/duotune/general/gen022.svg' className={btnIconClass} />
        </div>
        <HeaderNotificationsMenu />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTSVG path='/media/icons/duotune/communication/com012.svg' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div> */}

      <div className={clsx('app-navbar-item', itemClass)}>
        <div className='min-w-100px me-2'>
          <Select
            options={options2}
            placeholder='Select Currency'
            defaultValue={defaultValue}
            styles={customStyles}
            isDisabled
          />
        </div>
        <div
          className={clsx('cursor-pointer symbol symbol-circle', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          {currentUser?.user?.first_name && (
            <span className='symbol-label bg-warning text-inverse-warning fw-bold'>
              {currentUser?.user?.first_name.charAt(0).toUpperCase()}
              {currentUser?.user?.last_name.charAt(0).toUpperCase()}
            </span>
          )}
        </div>

        <HeaderUserMenu />
      </div>

      {/* {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className={btnIconClass} />
          </div>
        </div>
      )} */}
    </div>
  )
}

export {Navbar}
